"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrystalTargetLanguage = void 0;
const TargetLanguage_1 = require("../../TargetLanguage");
const CrystalRenderer_1 = require("./CrystalRenderer");
class CrystalTargetLanguage extends TargetLanguage_1.TargetLanguage {
    makeRenderer(renderContext) {
        return new CrystalRenderer_1.CrystalRenderer(this, renderContext);
    }
    constructor() {
        super("Crystal", ["crystal", "cr", "crystallang"], "cr");
    }
    get defaultIndentation() {
        return "  ";
    }
    getOptions() {
        return [];
    }
}
exports.CrystalTargetLanguage = CrystalTargetLanguage;
